import React from "react";
import { useTheme } from "../../context/ThemeContext";
import "./ThemeToggle.css";

/**
 * Animated sun/moon toggle for switching between light and dark mode.
 *
 * Usage:
 *   <ThemeToggle />
 *   <ThemeToggle showTooltip />
 *   <ThemeToggle className="my-extra-class" />
 */
const ThemeToggle = ({ showTooltip = false, className = "" }) => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <button
      type="button"
      className={`theme-toggle ${className}`}
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      {/* Sun icon — shown when in dark mode (user clicks to go light) */}
      <svg
        className="theme-toggle__icon theme-toggle__sun"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      </svg>

      {/* Moon icon — shown when in light mode (user clicks to go dark) */}
      <svg
        className="theme-toggle__icon theme-toggle__moon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>

      {showTooltip && (
        <span className="theme-toggle__tooltip">
          {isDark ? "Light mode" : "Dark mode"}
        </span>
      )}
    </button>
  );
};

export default ThemeToggle;
